export const APPCUES_ID = {
    FULL_SCREEN_MODAL_CLOSE_ICON: 'FULL_SCREEN_MODAL_CLOSE_ICON',
};
